module.exports = __webpack_public_path__ + "img/34_52.e4d80472.png";